export class ChartData {
  public isTransparent? = false;

  public color?: string;

  constructor(
    public label?: string,
    public value?: number, // hint was any in minubo - what other tyoes need to be supported?
    public isOther?: boolean,
    public secondLabel?: string,
    public colorIndex?: number
  ) {}
}
